import { Component, OnInit, ViewChild } from '@angular/core';
import { DoccardComponent } from 'src/app/doccard/doccard.component';
import {fromEvent} from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { MatTabGroup } from '@angular/material';

@Component({
  selector: 'app-docdashboard',
  templateUrl: './docdashboard.component.html',
  styleUrls: ['./docdashboard.component.css']
})
export class DocdashboardComponent implements OnInit {

  issummary :boolean = true;
  isdashboard : boolean = true;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );

  constructor(private logCard: DoccardComponent,
    private breakpointObserver: BreakpointObserver) {
    
    fromEvent(window, 'popstate')
    .subscribe((e) => {
     console.log(e, 'back button');
    });
    this.issummary = false;
    this.isdashboard = true;
    console.log("in dashboard constructor");
  }

  ngOnInit() {
    console.log("in dashboard init");
  }

  changeTab(event) {
    console.log("in change tab");
    if (event.index == 0) {
      this.goToSummary();
    }
  }

  goToSummary() {
    console.log("in go to food log");
    this.issummary = true;
    this.isdashboard = false;
  }

  goToDashBoard($event){
    console.log("going to dashboard");
    if ($event == "saved")
    this.issummary = false;
    this.isdashboard = true;
  }
}